import { useEffect } from 'react';

/**
 * Хук для обработки горячих клавиш
 * @param {Object} shortcuts - Объект с горячими клавишами и их обработчиками
 * @param {boolean} enabled - Включены ли горячие клавиши
 */
const useKeyboardShortcuts = (shortcuts, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyPress = (event) => {
      // Игнорируем горячие клавиши, если фокус в input, textarea или contenteditable
      const target = event.target;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return;
      }

      // Формируем строку комбинации клавиш
      const key = event.key.toLowerCase();
      let combo = '';
      
      if (event.ctrlKey) combo += 'ctrl+';
      if (event.altKey) combo += 'alt+';
      if (event.shiftKey) combo += 'shift+';
      combo += key;

      // Проверяем, есть ли обработчик для этой комбинации
      if (shortcuts[combo]) {
        event.preventDefault();
        shortcuts[combo](event);
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [shortcuts, enabled]);
};

export default useKeyboardShortcuts;











